import { createBooleanSimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/common/createBooleanSimpleFilterDefinition';

/**
 * AD Object Pre-Auth Not Required field definition
 * Boolean field with Yes/No dropdown for pre-authentication requirement status filtering
 */
export const ADObjectPreAuthNotRequired = createBooleanSimpleFilterDefinition(
  'dontreqpreauth',
  'Pre-Auth Not Required'
);
